import checkUpdatePassword from "./check-update-password.js";

export default {
	checkUpdatePassword,
};
